import { Buffer } from "buffer";
import { IWebinarLinkPayload } from "../ZoomAuth/interfaces";
import BaseService from "../../utils/BaseService";

export const getDecodedDataFromWebinarLink = (link: string) => {
  const url = new URL(link.replace("/#/", "/"));
  const token = url.searchParams.get("token");
  const tokenBuffer = Buffer.from(token || "", "base64");
  const tokenData = JSON.parse(tokenBuffer.toString("utf-8"));
  return tokenData;
};

export const getMeetingLinkFromData = async (data: IWebinarLinkPayload) => {
  const baseService = BaseService.getSharedInstance().axios;
  const url = "crm-communication/webinar/link";
  const response = await baseService.post(url, data);
  return response.data;
};

export const getMeetingTypeFromUrl = () => {
  const url = new URL(window.location.href.replace("/#/", "/"));
  const type = url.searchParams.get("type");
  return type;
};

export const getAppMeetingLink = async (data: {
  meetingOrWebinarId: string;
  meetingType: "MEETING" | "WEBINAR";
  contactUuid: string;
}): Promise<string> => {
  const meetingOrWebinarId = data.meetingOrWebinarId;
  const meetingType = data.meetingType;
  const contactUuid = data.contactUuid;
  const url = `crm-nest/public/app-meeting-link`;
  const baseService = BaseService.getSharedInstance().axios;
  const response = await baseService.post(url, {
    meetingOrWebinarId,
    type: meetingType,
    contactUuid,
  });
  return response?.data?.link;
};
